/* global axios */
import ApiClient from './ApiClient';

class WorkflowsAPI extends ApiClient {
  constructor() {
    super('workflows', { accountScoped: true });
  }

  publish(workflowId) {
    return axios.post(`${this.url}/${workflowId}/publish`);
  }

  capabilities() {
    return axios.get(`${this.url}/capabilities`);
  }
}

export default new WorkflowsAPI();
